'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);
require('react-intl-tel-input/dist/main.css');
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../constants');
var _constructLink = require('../../helpers/constructLink');

var _CompanyField = require('../../components/Company/CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);
var _components = require('../../components');






var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants2 = require('./constants');


var _PropertyDetailedContactsUsForm = require('./PropertyDetailedContactsUsForm.scss');var styles = _interopRequireWildcard(_PropertyDetailedContactsUsForm);
var _MobileContacts = require('../../components/MobileContacts/MobileContacts.scss');var contactsStyles = _interopRequireWildcard(_MobileContacts);

var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // components
// helpers
// styles
var PropertyDetailedFormComponent = function (_Component) {_inherits(PropertyDetailedFormComponent, _Component);function PropertyDetailedFormComponent(props) {_classCallCheck(this, PropertyDetailedFormComponent);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



































































    getPhoneInputRef = function (ref) {_this.phoneInputRef = ref;};_this.

    setCaretPosition = function (caretPos) {
      var elem = _this.phoneInputRef.tel;

      if (elem) {
        elem.focus();
        setTimeout(function () {
          elem.setSelectionRange(caretPos, caretPos);
        }, 0);
      }
    };_this.

    handleSelectCountry = function (first, countryData) {
      if (_this.state.phoneCode !== countryData.dialCode) {
        _this.setState({ phoneCode: countryData.dialCode, countryISOCode: countryData.iso2 });
      }
    };_this.

    handlePhoneNumberChange = function (isValid, inputData, countryData, phoneNumber) {
      var onlyNums = inputData.replace(/[^+\d\s-]/g, '');

      _this.props.change('phone', onlyNums);
      _this.setState({ isValidPhone: isValid });

      if (_this.state.phoneCode !== countryData.dialCode) {
        _this.setState({ phoneCode: countryData.dialCode, countryISOCode: countryData.iso2 });
      }
    };_this.

    submitForm = function (values) {var _this$props =







      _this.props,sendPropertyDetailedForm = _this$props.sendPropertyDetailedForm,sendPropertyRealtorForm = _this$props.sendPropertyRealtorForm,entityType = _this$props.entityType,isForeign = _this$props.isForeign,entityId = _this$props.entityId,locale = _this$props.locale;var
      name = values.name,email = values.email,phone = values.phone,aims = values.aims,message = values.message,messengers = values.messengers;

      var params = {
        name: name,
        aims: aims,
        email: email && email.toLowerCase(),
        phone_number: phone,
        message: message,
        messengers: messengers,
        locale: locale,
        country_code: _this.state.countryISOCode,
        phone_code: _this.state.phoneCode };


      _this.props.sendPropertiesAnalytics({
        affected_id: entityId,
        action: 'send-contact-form' });


      var sendToRealtor = !isForeign && entityType === 'property';
      if (sendToRealtor) {
        return sendPropertyRealtorForm(Object.assign({}, params, { property_id: entityId }));
      }
      return sendPropertyDetailedForm(Object.assign({},
      params, {
        entity_type: entityType,
        entity_id: entityId }));

    };_this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    };_this.

    renderOption = function (item) {return {
        id: item,
        label: '' + _this.props.translate('propertyDetailsContactsUsForm', item) };};_this.


    renderTextArea = function (_ref) {var input = _ref.input,placeholder = _ref.placeholder,maxLength = _ref.maxLength;return (
        _react2.default.createElement(_components.OMTextArea, _extends({
          placeholder: placeholder },
        input, {
          maxLength: maxLength,
          rows: 3 })));};_this.



    renderCheckbox = function (_ref2) {var input = _ref2.input,_ref2$meta = _ref2.meta,touched = _ref2$meta.touched,error = _ref2$meta.error,warning = _ref2$meta.warning,label = _ref2.label,className = _ref2.className,id = _ref2.id;return (
        _react2.default.createElement(_components.OMCheckbox, {
          id: input.name,
          label: label,
          className: (0, _classnames2.default)(className, { not_valid: error && touched }),
          field: Object.assign({}, input, { checked: input.value }) }));};_this.



    renderAgreeLabel = function () {
      var contactUsTranslate = _this.props.translate('propertyDetailsContactsUsForm');
      return (
        _react2.default.createElement('span', { className: styles.checkBoxlink },
          _react2.default.createElement('span', null, '' + contactUsTranslate('privacy')), '\xA0',

          _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '/privacy'), target: '_blank' }, '' +
            contactUsTranslate('linkPrivacy'))));



    };_this.

    renderPhone = function (_ref3) {var input = _ref3.input,_ref3$meta = _ref3.meta,error = _ref3$meta.error,touched = _ref3$meta.touched;return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputPhone, { 'has-error': error && touched }) },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            ref: _this.getPhoneInputRef
            // format // TODO Now it leads Ukrainian phones to double zero -> +380 093 ....
            , autoPlaceholder: false,
            nationalMode: false,
            containerClassName: (0, _classnames2.default)('intl-tel-input', styles.countrySelect),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone_number',
            value: input.value,
            preferredCountries: _constants2.PREFERRED_COUNTRIES,
            onPhoneNumberChange: _this.handlePhoneNumberChange,
            onSelectFlag: _this.handleSelectCountry,
            useMobileFullscreenDropdown: false,
            separateDialCode: true })));};_this.state = { sending: false, isValidPhone: true, phoneNumber: '', countryISOCode: 'il', phoneCode: null };return _this;}PropertyDetailedFormComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref4) {var propertyDetailedForm = _ref4.propertyDetailedForm,isMessageModalOpen = _ref4.isMessageModalOpen;var stateModifier = {};if (propertyDetailedForm.loading !== this.props.propertyDetailedForm.loading) {stateModifier.sending = propertyDetailedForm.loading;}if (propertyDetailedForm.loaded && propertyDetailedForm.loaded !== this.props.propertyDetailedForm.loaded) {(0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.newProject });this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('contactUsPage', 'formSent')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, this.props.translate('contactUsPage', 'ok')))), isCloseButtonInvisible: true });this.props.handleRequest && this.props.handleRequest();}if (propertyDetailedForm.error && propertyDetailedForm.error !== this.props.propertyDetailedForm.error) {this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'contentMessage' }, _react2.default.createElement('div', null, _react2.default.createElement('p', null, this.props.translate('contactUsPage', 'error')), _react2.default.createElement('button', { className: 'btn btn-primary', onClick: this.props.hideMessageModal }, this.props.translate('contactUsPage', 'ok')))) });this.props.handleRequest && this.props.handleRequest();}if (!isMessageModalOpen && propertyDetailedForm.loaded && this.props.isMessageModalOpen) {this.props.reset();}if (Object.keys(stateModifier).length) {this.setState(stateModifier);}};PropertyDetailedFormComponent.prototype.




  render = function render() {var _cx;var _props =
    this.props,translate = _props.translate,isMobile = _props.isMobile,isRtl = _props.isRtl,isModal = _props.isModal,locale = _props.locale,entityType = _props.entityType,isForeign = _props.isForeign;
    var contactUsTranslate = translate('propertyDetailsContactsUsForm');

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapper) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.container, 'propertyDetailsContent') },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.form, (_cx = {}, _cx[styles.inModal] = isModal, _cx)) },
            _react2.default.createElement('div', { className: styles.title }, contactUsTranslate(entityType === 'property' ? 'moreInfoPropertyTitle' : 'moreInfoTitle')),
            _react2.default.createElement('form', { className: styles.formContainer },
              _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputField, styles.nameLabel) },
                _react2.default.createElement('div', { className: styles.label }, contactUsTranslate('nameTitle')),
                _react2.default.createElement('div', { className: styles.fieldWrapper },
                  _react2.default.createElement(_reduxForm.Field, {
                    name: 'name',
                    component: _CompanyField2.default,
                    type: 'text',
                    placeholder: !isMobile ? '' + contactUsTranslate('namePlaceholder') : '',
                    translateForError: translate('errorFieldMessages'),
                    isRtl: isRtl,
                    maxLength: 15,
                    disabledMaxLength: true }))),



              _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputField, styles.fullWidth, styles.numberBlock) },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.label, styles.phoneLabel) },
                  contactUsTranslate('phoneTitle')),

                _react2.default.createElement('div', { className: styles.fieldWrapper },
                  _react2.default.createElement(_reduxForm.Field, {
                    name: 'phone',
                    type: 'text',
                    component: this.renderPhone,
                    value: this.state.phoneNumber }))),



              _react2.default.createElement('div', { className: styles.inputField },
                _react2.default.createElement('div', { className: styles.label }, '' + contactUsTranslate('textAreaLabel')),
                _react2.default.createElement('div', { className: styles.fieldWrapper },
                  _react2.default.createElement(_reduxForm.Field, {
                    name: 'message',
                    component: this.renderTextArea,
                    placeholder: !isMobile ? '' + contactUsTranslate('textAreaLabel') : '',
                    translateForError: translate('errorFieldMessages'),
                    isRtl: isRtl,
                    maxLength: 95 }))),



              _react2.default.createElement('div', { className: styles.privacy },
                !isMobile && _react2.default.createElement('div', { className: styles.label }),
                _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.fieldWrapper, styles.formLink) },
                  _react2.default.createElement(_reduxForm.Field, {
                    id: 'agree_property_detailed',
                    name: 'agree_property_detailed',
                    className: (0, _classnames2.default)(styles.checkBoxLabel, styles.checkBoxFull),
                    component: this.renderCheckbox,
                    label: this.renderAgreeLabel(),
                    translateForError: translate('errorFieldMessages') }))),



              _react2.default.createElement('div', { className: styles.btnSubmit },
                _react2.default.createElement(_components.OMButtonWithPreloader, {
                  showPreloader: this.state.sending,
                  onClick: this.handleSubmit,
                  innerText: '' + contactUsTranslate('buttonText') })))))));







  };return PropertyDetailedFormComponent;}(_react.Component);


PropertyDetailedFormComponent.propTypes = {
  isModal: _propTypes2.default.bool,
  handleRequest: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  change: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  sendPropertyDetailedForm: _propTypes2.default.func,
  sendPropertyRealtorForm: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  propertyDetailedForm: _propTypes2.default.object,
  propertyDetails: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  onPhoneNumberChange: _propTypes2.default.func,
  onPhoneNumberBlur: _propTypes2.default.func,
  sendPropertiesAnalytics: _propTypes2.default.func,
  entityId: _propTypes2.default.string,
  entityType: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool };exports.default =


PropertyDetailedFormComponent;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyDetailedContactsUsForm/PropertyDetailedFormComponent.js
// module id = 3034
// module chunks = 0